import React from 'react';
import * as styles from './styles.module.css';

function ActionButton({
  icon: Icon,
  text,
  disabled = false,
  onClick,
  className,
  title,
}) {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={`${styles['action-button']} ${className}`}
      disabled={disabled}
      title={title}
      onClick={handleClick}
    >
      {Icon && (
        <span className={styles['button-icon']}>
          <Icon />
        </span>
      )}
      {text && <span className={styles['button-text']}>{text}</span>}
    </button>
  );
}

export default ActionButton;
